<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">{{ $t('app.filter_by') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.code')}}</label>
              <el-form-item prop="Code">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.Code.value"
                  maxlength="30"
                />
              </el-form-item>
            </div>
            
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.name')}}</label>
              <el-form-item prop="Name">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.Name.value"
                  maxlength="100"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$tc('app.role', 1)}}</label>
              <el-form-item prop="Role">
                <el-select class="w-full" 
                  v-model="form.Role.value" 
                  filterable
                  clearable>
                    <el-option
                      v-for="opt in tiposRolesAdministrativeCentersFB2B"
                      :key="opt.id"
                      :label="opt.name"
                      :value="opt.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      vuexnamespace: 'administrativecentersfb2b',
      isOpen: this.panelOpen,
      form: {
        Code: { label: i18n.t('app.code'), value: '' },
        Name: { label: i18n.t('app.name'), value: '' },
        Role: { label: i18n.tc('app.role', 1), value: '' },
      },
      loadingData: false,
    }
  },
  computed: {
    tiposRolesAdministrativeCentersFB2B: function () {
      return this.$store.getters['config/TIPOS_ROL_ADMINISTRATIVE_CENTER_FB2B']
    },
  },
  mounted: async function () {
    // this.loadingData = true
    // const dataAgrupaciones = await getAgrupacionesNombreCompanies()
    // if (dataAgrupaciones.blnError === true) {
    //   this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataAgrupaciones))
    // }
    // this.listGrouping = dataAgrupaciones.Respuesta.map((x, i) => ({ key: i, label: x, value: x }))
    // this.loadingData = false
  },
  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.Code.value = _temp.Code !== undefined && _temp.Code.value !== '' ? _temp.Code.value : ''
        this.form.Name.value = _temp.Name !== undefined && _temp.Name.value !== '' ? _temp.Name.value : ''
        this.form.Role.value = _temp.Role !== undefined && _temp.Role.value !== '' ? _temp.Role.value : ''
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        Code: { label: i18n.t('app.code'), value: '' },
        Name: { label: i18n.t('app.name'), value: '' },
        Role: { label: i18n.tc('app.role', 1), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    }
  }
}
</script>

<style lang="scss" scoped></style>
